module.exports = __webpack_public_path__ + "media/images/favicon/favicon-test-622626d5ebcf5db9c3dafef9d45b627c.ico";